import { ConvertToWallet, WalletType } from 'types/types'
import { postConvert } from 'types/wallets'
import { ConvertDetailsForm, ConvertDetailsFormData } from './schemas/convertDetailsSchema'

const getIdField = (key: 'fromWallet' | 'toWallet', wallet: ConvertToWallet) => {
  if (wallet.lsid) {
    return { [`${key}Lsid`]: wallet.lsid }
  }
  return { [key]: wallet.id }
}

export const getQuotePayload = (
  convertFromWallet: WalletType | undefined,
  convertToWallet: ConvertToWallet | undefined,
  formValues: ConvertDetailsForm | ConvertDetailsFormData | undefined,
  lastChangedField: string | undefined
) => {
  if (!convertFromWallet || !convertToWallet || !formValues) return

  const data: postConvert = {
    from: convertFromWallet.currency.code,
    to: convertToWallet.currency.code,
    ...getIdField('fromWallet', convertFromWallet),
    ...getIdField('toWallet', convertToWallet),
    useMaximum: false,
    useMinimum: false,
    ...(formValues.reference && { reference: formValues.reference }),
    ...(lastChangedField === 'toAmount'
      ? { amountOut: formValues?.toAmount?.toString() }
      : { amountIn: formValues?.fromAmount?.toString() }),
  }

  return data
}
